import config from '../../config/app';

const _roleIsAtLeast = (targetRole, currentRole, roles) => {
  const targetIndex = roles.indexOf(targetRole);
  const currentIndex = roles.indexOf(currentRole);
  return (currentIndex >= 0) && (targetIndex >= currentIndex);
};

// General access
export const currentUserData = state => state.feData.user;

export const currentUserId = state => currentUserData(state).id;

export const currentUserAccountData = state => state.feData.account;

export const currentUserAccountFeatures = state => state.feData.accountFeatures.features || [];

export const currentUserPermissions = state => state.feData.permissions;

export const allRoles = state => state.feData.roles;

export const currentUserAddons = state => currentUserAccountData(state).accountsAddons;

export const isFlagEnabled = state => flag => currentUserAccountFeatures(state).includes(flag);

export const isFeDataLoaded = state => state.feData.isLoaded;

export const isFeDataFetching = state => state.feData.isFetching;

// Toggles

export const currentUserToggles = state => (
  currentUserData(state).toggles ? currentUserData(state).toggles : []
);

export const isToggleEnabled = state => toggle => (
  currentUserToggles(state).some(t => t.name === toggle)
);

export const hasFeature = state => isFlagEnabled(state)(config.FEATURE_FLAG)
  || isToggleEnabled(state)(config.FEATURE_TOGGLE);

// Roles

export const currentUserRole = state => currentUserData(state).role;

export const isCurrentUserAnAccountOwner = state => currentUserRole(state) === 'owner';

export const isCurrentUserAnAdmin = state => currentUserRole(state) === 'admin';

export const isCurrentUserReadOnlyLimited = state => currentUserRole(state) === 'read_only_limited_user';

export const isCurrentUserReadOnly = state => isCurrentUserReadOnlyLimited(state) || currentUserRole(state) === 'read_only_user';

export const isCurrentUserRestricted = state => currentUserRole(state) === 'restricted_access';

export const roleIsUserOrGreater = state => _roleIsAtLeast('user', currentUserRole(state), allRoles(state));

export const roleIsAdminOrGreater = state => _roleIsAtLeast('admin', currentUserRole(state), allRoles(state));

export const currentUserAccountState = state => state.feData.account.state;

// Abilities
export const hasAbility = state => ability => state.feData.abilities[ability];

// Account state

export const isCurrentUserAccountExpired = state => currentUserAccountState(state) === 'expired';

export const isCurrentUserAccountTrial = state => currentUserAccountState(state) === 'trial';

export const isCurrentUserAccountActive = state => currentUserAccountState(state) === 'active';

export const isCurrentUserAccountLocked = state => currentUserAccountState(state) === 'locked';

export const currentUserAccountPlan = state => state.feData.account.plan;

export const isCurrentUserAccountLite = state => currentUserAccountPlan(state).includes('lite');

export const isCurrentUserAccountStarter = state => currentUserAccountPlan(state).includes('starter');

export const isCurrentUserAccountStandard = state => currentUserAccountPlan(state).includes('standard');

export const isCurrentUserAccountEnterprise = state => currentUserAccountPlan(state).includes('enterprise');

export const isCurrentUserAccountEnterprise2015 = state => currentUserAccountPlan(state) === 'enterprise_2015_04';

export const isCurrentUserAccountPlatform = state => currentUserAccountPlan(state) === 'platform';

export const isPDTSubdomain = state => currentUserAccountData(state).subdomain.substr(0, 4) === 'pdt-';

// Other
export const isCurrentUserSpoofed = state => Boolean(currentUserData(state).spoofOrigin);

export const isUserDataValid = ({ feData: { user, account } }) => Boolean(
  user && user.id && account && account.id
);
